import { render, staticRenderFns } from "./board_view.vue?vue&type=template&id=71bfa369&scoped=true&"
import script from "./board_view.vue?vue&type=script&lang=js&"
export * from "./board_view.vue?vue&type=script&lang=js&"
import style0 from "./board_view.vue?vue&type=style&index=0&id=71bfa369&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bfa369",
  null
  
)

export default component.exports